export const PAGE_PATH = {
  AGENT_PLAYER: '/p',
  AGENTS: '/a',
  AUTOMATIONS: '/automations',
  CALLBACK: '/callback',
  DASHBOARD: '/dashboard',
  HOME: '/',
  PLANS: '/pricing',
  RESULTS: '/results',
  SCHEDULED_TASKS: '/scheduled-tasks',
  COPILOT: '/copilot',
  COPILOT_TEMPLATE: '/template',
  LIBRARY: '/library',
  THREADS: '/threads',
  WORKFLOW: '/workflow',
} as const
